import React from 'react';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Media,
    Badge,
    Button,
    Col,
    Row,
    Spinner,
    // CustomInput
} from 'reactstrap';
import UiLoader from '../../../components/custom/ui-loader';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as Icon from 'react-feather';
import { history } from '../../../history';
import AbstractProfileLogout from '../../../lib/abstractcomponent/auth/profileLogout';
import { connect, useSelector } from 'react-redux';
import CartModal from '../../../views/pages/Order/MyCart/cartModal';
import ReactTooltip from 'react-tooltip';
import { changeMode } from '../../../redux/actions/customizer/index';
const { type } = require('../../../configs/constant');

const UserDropdown = (props) => {
    let user_type = localStorage.user_type;
    let old_buyer = localStorage.old_buyer;
    return (
        <DropdownMenu right>
            {props.state.userDetails && props.state.userDetails.type === 2 ? (
                <DropdownItem
                    className="w-100"
                    onClick={(e) => history.push(`${process.env.PUBLIC_URL}/buyer/view-profile`)}
                >
                    <Icon.Eye size={14} className="mr-50" />
                    <span className="align-middle">Buyer Profile</span>
                </DropdownItem>
            ) : (
                ''
            )}
            {user_type &&
            user_type === '2' &&
            (props?.state?.userDocumentValue === null || props?.state?.userDocumentValue?.is_approve_document !== 1) &&
            old_buyer === 'false' ? (
                <DropdownItem
                    className="w-100"
                    onClick={(e) => history.push(`${process.env.PUBLIC_URL}/buyer/fill-document`)}
                >
                    <Icon.FilePlus size={14} className="mr-50" />
                    <span className="align-middle">Buyer Document</span>
                </DropdownItem>
            ) : (
                ''
            )}
            <DropdownItem
                className="w-100"
                onClick={(e) => {
                    if (user_type === '2') {
                        history.push(`${process.env.PUBLIC_URL}/buyer/account-settings`);
                    } else {
                        history.push(`${process.env.PUBLIC_URL}/account-settings`);
                    }
                }}
            >
                <Icon.Settings size={14} className="mr-50" />
                <span className="align-middle">Account Settings</span>
            </DropdownItem>
            <DropdownItem className="w-100" onClick={props.logout}>
                <Icon.LogOut size={14} className="mr-50" />
                <span className="align-middle">Log Out</span>
            </DropdownItem>
        </DropdownMenu>
    );
};

const ThemeToggler = (props) => {
    const customizerData = useSelector((state) => state.customizer);

    if (customizerData.customizer.theme === 'dark') {
        return (
            <div
                className="mx-1"
                onClick={() => {
                    localStorage.setItem('skin', 'light');
                    props.dispatch(changeMode('light'));
                }}
            >
                <Icon.Sun
                    className="ficon cursor-pointer text-white"
                    data-place="bottom"
                    data-for="positionDarkButton"
                    data-background-color="#7367f0"
                    data-text-color="white"
                />
                <ReactTooltip id="positionDarkButton" />
            </div>
        );
    } else {
        return (
            <div
                className="mx-1"
                onClick={() => {
                    localStorage.setItem('skin', 'dark');
                    props.dispatch(changeMode('dark'));
                }}
            >
                <Icon.Moon
                    className="ficon cursor-pointer"
                    data-tip="Dark Mode On"
                    data-place="bottom"
                    data-for="positionLightButton"
                    data-background-color="#ff0000"
                    data-text-color="white"
                />
                <ReactTooltip id="positionLightButton" />
            </div>
        );
    }
};
class NavbarUser extends AbstractProfileLogout {
    handleNavbarSearch = () => {
        this.setState({
            navbarSearch: !this.state.navbarSearch,
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const { cartCount } = this.state;
        if (cartCount !== prevState.cartCount) {
            let UserType = localStorage.getItem('user_type');
            if (UserType !== type.buyer.toString()) {
                if (this.props.cart.cartItems.length > 0) {
                    this.setState({ cartCount: this.props.cart.cartItems.length });
                } else {
                    this.setState({ cartCount: 0 });
                }
            }
        }
    }

    toggleNotificationDropdown = () => {
        this.setState({ notificationList: !this.state.notificationList });
    };

    toggleDropdown = () => {
        this.setState((prevState) => {
            const isDropdownOpen = !prevState.isDropdownOpen;
            return { isDropdownOpen };
        });
    };

    toggleMarkAll = () => {
        const { notification } = this.state;
        const allRead = this.areAllNotificationsRead();
        const updatedNotifications = notification.map((data) => ({
            ...data,
            read: !allRead,
        }));
        this.setState({
            notification: updatedNotifications,
        });
    };

    areAllNotificationsRead() {
        return this.state.notification.every((data) => data.is_read);
    }

    handleReadAllClick = () => {
        const { history } = this.props;
        history.push(`${process.env.PUBLIC_URL}/settings/notification/notificationList`);
        this.setState({ isDropdownOpen: false });
    };

    render() {
        const { notificationList, isDropdownOpen, isLoadingDisplay } = this.state;
        const iconMapping = {
            END_OFFER: <Icon.Clock />,
            START_OFFER: <Icon.Clock />,
            CHEQUE_RESOLVED: <Icon.CreditCard />,
            CHEQUE_BOUNCED: <Icon.CreditCard />,
            CHEQUE_SUBMIT: <Icon.CreditCard />,
            TARGET_COMPLETION: <Icon.Star />,
            TARGET_SET: <Icon.Target />,
            ORDER_DELIVERED: <Icon.CheckCircle />,
            TARGET_ACHIEVED: <Icon.Star />,
            USER_REGISTER: <Icon.User />,
            ORDER_PLACED: <Icon.ShoppingBag />,
            BUYER_ORDER_PLACED: <Icon.ShoppingBag />,
        };
        const pathMapping = {
            END_OFFER: `${process.env.PUBLIC_URL}/order/place-order`,
            START_OFFER: `${process.env.PUBLIC_URL}/order/place-order`,
            CHEQUE_RESOLVED: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
            CHEQUE_BOUNCED: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
            CHEQUE_SUBMIT: `${process.env.PUBLIC_URL}/cheque/cheque-list`,
            TARGET_COMPLETION: `${process.env.PUBLIC_URL}/settings/users`,
            TARGET_SET: `${process.env.PUBLIC_URL}/salesman/dashboard`,
            ORDER_DELIVERED: `${process.env.PUBLIC_URL}/order/order-history`,
            TARGET_ACHIEVED: `${process.env.PUBLIC_URL}/salesman/dashboard`,
            USER_REGISTER: `${process.env.PUBLIC_URL}/settings/users`,
            ORDER_PLACED: `${process.env.PUBLIC_URL}/order/order-history`,
            BUYER_ORDER_PLACED: `${process.env.PUBLIC_URL}/order/buyer-order-history`,
        };
        const formatNotificationDate = (created_at) => {
            const currentDate = moment();
            const notificationDate = moment(created_at, 'YYYY-MM-DD, hh:mm A');
            if (notificationDate.isSame(currentDate, 'day')) {
                return moment(created_at).format('[Today], hh:mm A');
            } else if (notificationDate.isSame(currentDate.clone().subtract(1, 'day'), 'day')) {
                return moment(created_at).format('[Yesterday], hh:mm A');
            } else {
                return moment(created_at).format('DD MMM hh:mm A');
            }
        };
        const markAllAsRead = (data) => {
            if (!data.is_read) {
                this.setState({ isLoadingDisplay: true });
                this.GetMarkAllNotificationAsRead(data.notification_id, data.notification_key);
                return {
                    ...data,
                    is_read: true,
                };
            }
            return data;
        };

        const bellIconCount = this.props.notifications.filter((x) => !x.is_bell_icon_read);

        return (
            <ul className="nav navbar-nav navbar-nav-user d-flex justify-content-end align-items-center">
                <UncontrolledDropdown
                    tag="li"
                    className="dropdown-notification nav-item mr-25"
                    isOpen={
                        !window.location.pathname.includes('/settings/notification/notificationList') && isDropdownOpen
                    }
                    toggle={this.toggleDropdown}
                >
                    <DropdownToggle tag="a" className="nav-link" href="/" onClick={(e) => e.preventDefault()}>
                        <Icon.Bell
                            size={22}
                            onClick={() => this.GetReadNotificationListOnBellIcon()}
                            className={
                                window.location.pathname.includes('/settings/notification/notificationList')
                                    ? 'filled'
                                    : ''
                            }
                        />

                        {!window.location.pathname.includes('/settings/notification/notificationList') &&
                            this.props.notifications.length > 0 && (
                                <span
                                    className="badge badge-pill badge-primary ml-auto mr-1"
                                    style={{ position: 'absolute', top: '6px', right: '-5px', fontSize: '10px' }}
                                >
                                    {bellIconCount.length}
                                </span>
                            )}
                    </DropdownToggle>
                    <DropdownMenu
                        tag="ul"
                        right
                        className="dropdown-menu-media"
                        style={{ backgroundColor: '$primary' }}
                    >
                        <UiLoader
                            blocking={isLoadingDisplay}
                            overlayColor="rgba(115, 103, 240, 0.1)"
                            loader={<Spinner color="primary" />}
                        >
                            <DropdownItem
                                className="d-flex notificationHeader"
                                header
                                style={{ borderBottom: 'solid 1px gray' }}
                            >
                                <p className="mb-0 mr-auto" style={{ fontSize: 20 }}>
                                    Notifications
                                </p>
                                <div
                                    className="d-flex align-items-center"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => markAllAsRead((data) => data.is_read)}
                                >
                                    {this.areAllNotificationsRead() ? '' : 'Mark All as Read'}
                                </div>
                            </DropdownItem>
                            <PerfectScrollbar
                                className="media-list scrollable-container"
                                options={{ wheelPropagation: false }}
                            >
                                {this.props.notifications.length > 0 ? (
                                    <>
                                        {this.props.notifications.slice(0, 7).map((data, notification_key) => (
                                            <div
                                                key={notification_key}
                                                className={`dropdown-item-notification ${
                                                    data.is_read ? 'read' : 'unread'
                                                }`}
                                                style={{
                                                    whiteSpace: 'normal',
                                                    padding: '8px 16px',
                                                    lineHeight: 1.5,
                                                    transition: 'background-color 0.1s',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <Link
                                                    to={pathMapping[data.notification.notification_key]}
                                                    className="notificationList hover-item"
                                                    style={{ textDecoration: 'none' }}
                                                    onClick={() => {
                                                        if (!data.is_read) {
                                                            this.GetReadNotificationById(data.notification_id);
                                                        }
                                                    }}
                                                >
                                                    <Row>
                                                        <Col
                                                            lg="1"
                                                            md="1"
                                                            sm="1"
                                                            xs="1"
                                                            style={{ paddingTop: '0.5rem' }}
                                                        >
                                                            {iconMapping[data.notification.notification_key]}
                                                        </Col>
                                                        <Col
                                                            lg="8"
                                                            md="8"
                                                            sm="8"
                                                            xs="8"
                                                            style={{ lineHeight: 2 }}
                                                            className="pt-0"
                                                        >
                                                            <div style={{ fontWeight: 900, fontSize: 14 }}>
                                                                {data.notification.title}
                                                            </div>
                                                            <div style={{ fontWeight: 600, fontSize: 12 }}>
                                                                {data.notification.description}
                                                            </div>
                                                            {data.notification.notification_key !== 'USER_REGISTER' ? (
                                                                <div style={{ fontSize: 12 }}>
                                                                    {data.user.type === 2
                                                                        ? data.user.company_name +
                                                                          ' ' +
                                                                          data.user.shop_name
                                                                        : data.user.first_name +
                                                                          ' ' +
                                                                          data.user.last_name}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </Col>
                                                        <Col lg="2" md="2" sm="2" xs="2" className="px-0">
                                                            <div style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                {formatNotificationDate(data.created_at)}
                                                            </div>
                                                        </Col>
                                                        <Col lg="1" md="1" sm="1" xs="1" className="my-1">
                                                            {!data.is_read && <div className="unread-dot" />}
                                                        </Col>
                                                    </Row>
                                                </Link>
                                            </div>
                                        ))}
                                    </>
                                ) : this.props.notifications.length === 0 && this.state.isLoadingDisplay === false ? (
                                    <p className="text-center pt-2">No Notifications Available</p>
                                ) : (
                                    ''
                                )}
                            </PerfectScrollbar>
                            <li className="d-flex justify-content-end p-1" style={{ borderTop: 'solid 1px' }}>
                                {this.props.notifications.length > 0 ? (
                                    <div
                                        className="readAll"
                                        style={{ fontSize: '1.1rem', cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={this.handleReadAllClick}
                                    >
                                        Read All
                                    </div>
                                ) : (
                                    ''
                                )}
                            </li>
                        </UiLoader>
                    </DropdownMenu>
                </UncontrolledDropdown>

                <ThemeToggler dispatch={this.props.dispatch} />

                {/* Start Of Cart Component*/}
                <UncontrolledDropdown tag="li" className="dropdown-notification nav-item">
                    <DropdownToggle
                        tag="a"
                        className="nav-link nav-link-label"
                        onClick={this.cartModal}
                        // data-tip="Cart"
                        data-place="bottom"
                        data-for="positionCartButton"
                        data-background-color="#7367f0"
                        data-text-color="white"
                    >
                        <Icon.ShoppingCart size={21} />
                        <Badge pill color="primary" className="badge-up">
                            {this.props.cart.cartItems.length}
                        </Badge>
                    </DropdownToggle>
                    <ReactTooltip id="positionCartButton" />
                </UncontrolledDropdown>
                <CartModal state={this.state} cartModal={this.cartModal} cartModalClose={this.cartModalClose} />
                {/* End Of Cart Component*/}

                {notificationList.length > 0 ? (
                    <UncontrolledDropdown tag="li" className="dropdown-notification nav-item">
                        <DropdownToggle tag="a" className="nav-link nav-link-label" onClick={this.getUserWmsList}>
                            <Icon.Bell size={21} />
                            <Badge pill color="primary" className="badge-up">
                                {' '}
                                {notificationList.length}{' '}
                            </Badge>
                        </DropdownToggle>
                        <DropdownMenu tag="ul" right className="dropdown-menu-media">
                            <li className="dropdown-menu-header">
                                <div className="dropdown-header mt-0">
                                    <h3 className="text-white">{notificationList.length} New</h3>
                                    <span className="notification-title">App Notifications</span>
                                </div>
                            </li>
                            <PerfectScrollbar
                                className="media-list overflow-hidden position-relative"
                                options={{
                                    wheelPropagation: false,
                                }}
                            >
                                {notificationList.map((data, i) =>
                                    i <= 4 ? (
                                        <div className="d-flex justify-content-between">
                                            <Media className="d-flex align-items-start">
                                                <Media left href="#">
                                                    <Icon.PlusSquare className="font-medium-5 primary" size={21} />
                                                </Media>
                                                <Media body>
                                                    <Media heading className="primary media-heading" tag="h6">
                                                        {data.notification.meta_notification_key}
                                                    </Media>
                                                    <p className="notification-text">
                                                        Are your going to meet me tonight?
                                                    </p>
                                                </Media>
                                                <small>
                                                    <time className="media-meta" dateTime="2015-06-11T18:29:20+08:00">
                                                        {moment(data.updated_at).fromNow()}
                                                        {/* 9 hours ago */}
                                                    </time>
                                                </small>
                                            </Media>
                                        </div>
                                    ) : (
                                        ''
                                    ),
                                )}
                                {/* <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.DownloadCloud
                      className="font-medium-5 success"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="success media-heading" tag="h6">
                      99% Server load
                    </Media>
                    <p className="notification-text">
                      You got new order of goods?
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      5 hours ago
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.AlertTriangle
                      className="font-medium-5 danger"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="danger media-heading" tag="h6">
                      Warning Notification
                    </Media>
                    <p className="notification-text">
                      Server has used 99% of CPU
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Today
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.CheckCircle
                      className="font-medium-5 info"
                      size={21}
                    />
                  </Media>
                  <Media body>
                    <Media heading className="info media-heading" tag="h6">
                      Complete the task
                    </Media>
                    <p className="notification-text">
                      One of your task is pending.
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Last week
                    </time>
                  </small>
                </Media>
              </div>
              <div className="d-flex justify-content-between">
                <Media className="d-flex align-items-start">
                  <Media left href="#">
                    <Icon.File className="font-medium-5 warning" size={21} />
                  </Media>
                  <Media body>
                    <Media heading className="warning media-heading" tag="h6">
                      Generate monthly report
                    </Media>
                    <p className="notification-text">
                      Reminder to generate monthly report
                    </p>
                  </Media>
                  <small>
                    <time
                      className="media-meta"
                      dateTime="2015-06-11T18:29:20+08:00"
                    >
                      Last month
                    </time>
                  </small>
                </Media>
              </div>*/}
                            </PerfectScrollbar>
                            <li className="dropdown-menu-footer">
                                <DropdownItem tag="a" className="p-1 text-center">
                                    <Button className="w-100" color="primary" type="button">
                                        Read all notifications
                                    </Button>
                                </DropdownItem>
                            </li>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                ) : (
                    ''
                )}

                <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
                    <DropdownToggle tag="a" className="nav-link dropdown-user-link">
                        <div className="user-nav d-flex">
                            <span className="user-name text-bold-600 d-inline-block">
                                {/* need to add condition */}
                                <Icon.User />
                            </span>
                            {/* <span className="user-name text-bold-600 d-none d-md-block">
                                {userDetails !== undefined && userDetails !== null
                                    ? userDetails.type === 2
                                        ? userDetails.company_name + ' ' + userDetails.shop_name
                                        : userDetails.first_name + ' ' + userDetails.last_name
                                    : ''}
                            </span> */}
                        </div>
                    </DropdownToggle>
                    <UserDropdown {...this.props} state={this.state} logout={this.handleLogOut} />
                </UncontrolledDropdown>
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.userAuthentication.isAuthenticated,
        role: state.userAuthentication.role,
        cart: state.cart,
        notifications: state.notifications.list,
    };
};
export default connect(mapStateToProps)(withRouter(NavbarUser));
